/**
 * Alive Water — waterfall jug (GSAP), same logic as product.delivery custom_blurb_slider custom_html.
 * Inits each root with [data-alive-waterfall-gsap]; foam groups start empty and are filled here.
 */
(function () {
  'use strict';

  var gsapPromise = null;

  function loadGsap(callback) {
    if (window.gsap) {
      callback(window.gsap);
      return;
    }
    if (gsapPromise) {
      gsapPromise.then(function () {
        callback(window.gsap);
      });
      return;
    }
    gsapPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js';
      s.async = true;
      s.onload = function () {
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    gsapPromise.then(function () {
      callback(window.gsap);
    });
  }

  function initWaterfallGsap(root) {
    if (!root || root.getAttribute('data-gsap-init') === '1') return;
    if (!window.gsap) return;

    root.setAttribute('data-gsap-init', '1');

    var gsap = window.gsap;
    var foamId = root.getAttribute('data-foam-id') || 'foam';
    var foamRef = '#' + foamId;

    function createFoamElements(groupSelector, count) {
      var group = root.querySelector(groupSelector);
      if (!group) return;
      for (var i = 0; i < count; i++) {
        var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        use.setAttribute('href', foamRef);
        use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', foamRef);
        group.appendChild(use);
      }
    }

    createFoamElements('.whiteFoamGroup', 11);
    createFoamElements('.lightBlueFoamGroup', 11);
    createFoamElements('.darkBlueFoamGroup', 11);
    createFoamElements('.splashGroup', 8);

    var ripple = root.querySelector('.ripple');
    var whiteFoamElements = root.querySelectorAll('.whiteFoamGroup use');
    var lightBlueFoamElements = root.querySelectorAll('.lightBlueFoamGroup use');
    var darkBlueFoamElements = root.querySelectorAll('.darkBlueFoamGroup use');
    var splashElements = root.querySelectorAll('.splashGroup use');

    if (!ripple || whiteFoamElements.length === 0) {
      root.removeAttribute('data-gsap-init');
      return;
    }

    function getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }

    var mainTimeline = gsap.timeline({
      repeat: -1,
      yoyo: true,
      repeatDelay: 1
    });

    var rippleTimeline = gsap.timeline({
      repeat: -1,
      onRepeat: function () {
        var currentColor = ripple.getAttribute('fill');
        ripple.setAttribute('fill', currentColor === '#98E9FA' ? '#6ADFF7' : '#98E9FA');
      }
    });

    var splashTimeline = gsap.timeline({
      repeat: -1,
      repeatDelay: 1
    });

    gsap.set(splashElements, {
      transformOrigin: '50% 50%',
      fill: '#FFF'
    });

    function createFoamAnimation(elements, color, yRange, scaleBase) {
      for (var i = 0; i < elements.length; i++) {
        (function (element, index) {
          var scale = Math.random() + scaleBase;

          gsap.set(element, {
            x: index * 23,
            scale: scale,
            y: getRandomNumber(yRange[0], yRange[1]),
            transformOrigin: '50% 50%',
            fill: color
          });

          var timeline = gsap.timeline({
            repeat: -1,
            yoyo: true
          });

          timeline
            .to(element, Math.random() * 3 + 3, {
              scale: 2,
              ease: 'sine.inOut'
            })
            .to(element, Math.random() * 3 + 3, {
              scale: scale,
              ease: 'sine.inOut'
            });

          mainTimeline.add(timeline, index / 100);
        })(elements[i], i);
      }
    }

    function createSplashAnimation(elementId, element, xPosition) {
      if (xPosition == null) {
        xPosition = getRandomNumber(-10, 240);
      }

      var timeline = gsap.timeline({
        repeat: 0,
        onComplete: function () {
          createSplashAnimation(element.id, element, getRandomNumber(-10, 240));
        }
      });

      timeline
        .set(element, {
          scale: getRandomNumber(1, 16) / 10,
          y: -30,
          x: xPosition
        })
        .to(element, getRandomNumber(12, 16), {
          scale: 0
        });

      timeline.timeScale(splashTimeline.timeScale());
      element.id = elementId;
    }

    rippleTimeline.to(ripple, 2.7, {
      y: 320,
      x: -225,
      ease: 'none'
    });

    createFoamAnimation(whiteFoamElements, '#FFF', [-5, 1], 0.6);
    createFoamAnimation(lightBlueFoamElements, '#7EE7F9', [28, 40], 2);
    createFoamAnimation(darkBlueFoamElements, '#52E1F1', [63, 73], 3);

    mainTimeline.timeScale(1);
    splashTimeline.timeScale(6);
    splashTimeline.add(mainTimeline, 0);
    splashTimeline.add(rippleTimeline, 0);

    for (var j = 0; j < splashElements.length; j++) {
      createSplashAnimation(root.id + '-splash-' + j, splashElements[j]);
    }

    var svgEl = root.querySelector('svg');
    if (svgEl) gsap.set(svgEl, { visibility: 'visible' });
  }

  function scan() {
    loadGsap(function () {
      var roots = document.querySelectorAll('[data-alive-waterfall-gsap]');
      for (var i = 0; i < roots.length; i++) {
        initWaterfallGsap(roots[i]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.querySelector) return;
    var sec = t.matches('[data-alive-benefits]') ? t : t.querySelector('[data-alive-benefits]');
    if (!sec) return;
    loadGsap(function () {
      var roots = sec.querySelectorAll('[data-alive-waterfall-gsap]');
      for (var i = 0; i < roots.length; i++) {
        initWaterfallGsap(roots[i]);
      }
    });
  });
})();
